(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('li.popup-menu').each(function () {
		var menu = $(this);

		// Open dropdowns on click
		menu.find('a.dropdown-toggle').on('click', function (e) {
			e.preventDefault();
			$(this).next('ul.dropdown-menu').toggleClass('open');
		});

		// Close on outside click
		$(document.body).on('click', function (e) {
			var clicked = $(e.target);

			if (!(
				clicked.is('a.dropdown-toggle') ||
				clicked.parents('a.dropdown-toggle').length ||
				clicked.is('ul.dropdown-menu') ||
				clicked.parents('ul.dropdown-menu').length
			)) {
				$('ul.dropdown-menu').removeClass('open');
			}
		});
	});
})();
